export const PROFILE_TABS = [
  { label: 'General Information' },
  { label: 'Password' },
];
